//src/pages/Checkout.jsx

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API from "../services/api";
//import { initiatePayment } from "../services/payments";

import { initiateFlutterwavePayment } from "../services/payments";

const Checkout = () => {
  const { id } = useParams(); // product id
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [email, setEmail] = useState("");

  // Auth Guard
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      // Save product ID for after login
      localStorage.setItem("pending_product_id", id);

      window.location.href =
        "https://creator-mvp-hvdx.onrender.com/auth/twitter/url";
    }
  }, [id]);
  // Fetch products
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await API.get(`/products/`);
        const found = res.data.find((p) => p.id === parseInt(id));

        if (!found) {
          alert("Product not found");
          navigate("/");
          return
        }

        setProduct(found);

        //Save full product (for resume after login )
        localStorage.setItem("pending_product", JSON.stringify(found));
      } catch (err) {
        console.error("Error loading product:", err);
      }
    };

    fetchProduct();
  }, [id, navigate]);

  //const handlePayment = async () => {
    //try {
      //const res = await initiatePayment({
        //email,
        //amount: product.price,
       // product_id: product.id,
      //});

      //console.log("PAYSTACK INIT:", res);

      //const paymentUrl = res.data?.authorization_url;

      //if (paymentUrl) {
        //window.location.href = paymentUrl; // redirect to Paystack
      //} else {
        //alert("Failed to start payment");
      //}
    //} catch (err) {
      //console.error(err);
      //alert("Payment error");
    //}
  //};

  const handlePayment = async () => {
    try {
      if (!email) {
        alert("Enter your email");
        return;
      }
  
      const res = await initiateFlutterwavePayment({
        email,
        amount: product.price,
        product_id: product.id,
      });
  
      console.log("FLW INIT:", res);
  
      const paymentLink = res?.data?.link;
  
      if (paymentLink) {
        window.location.href = paymentLink; // ✅ redirect to Flutterwave
      } else {
        throw new Error("No payment link");
      }
    } catch (err) {
      console.error(err);
      alert("Payment error");
    }
  };

  if (!product) {
    return <h2>Loading checkout... ⏳</h2>;
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>💳 Checkout</h1>

      <div style={{ marginTop: 20 }}>
        <h2>{product.title}</h2>
        <p>{product.description}</p>
        <h3>₦{product.price}</h3>
      </div>

      <div style={{ marginTop: 20 }}>
        <input
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ padding: 10, width: 300 }}
        />
      </div>

      <button
        onClick={handlePayment}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          background: "black",
          color: "#fff",
          border: "none",
          borderRadius: 5,
        }}
      >
        Pay Now
      </button>
    </div>
  );
};

export default Checkout;